import Yup from "../../../utilities/yupExtensions";
import { FACTOR_TYPES } from "../components/upload-single-batch-user-form/UploadSingleBatchUserForm";

export const generatedValidationsForDynamicFields = (fields) => {
  if (!Object.keys(fields).length) {
    return Yup.object().shape({});
  }

  const validations = {};

  fields.forEach((field) => {
    if (field.type === FACTOR_TYPES.STRING) {
      validations[field.name] = Yup.string()
        .required(field.validationMessage || undefined)
        .label(field.description);
    }

    if (field.type === FACTOR_TYPES.NUMERIC) {
      validations[field.name] = Yup.string()
        .required(field.validationMessage || undefined)
        .label(field.description);
    }

    if (field.type === FACTOR_TYPES.DATE) {
      validations[field.name] = Yup.string()
        .required(field.validationMessage || undefined)
        .nullable()
        .label(field.description);
    }

    if (field.type === FACTOR_TYPES.OPTION) {
      validations[field.name] = Yup.string()
        .required(field.validationMessage || undefined)
        .nullable()
        .label(field.description);
    }
  });

  return Yup.object().shape({
    clientParams: Yup.object().shape({ ...validations }),
  });
};



// WEBPACK FOOTER //
// ./src/features/score-card/validation-schemas/scoreCardCalculate.js